/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import './AirTicketTile.css';
import { Grid } from '@mui/material';
import { fonts, themes } from '../../themes/themes';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { DateField } from '../../../components';
import { baseDateFormatting } from '../../helper';
import moment from 'moment';

interface contentTileType {
  ticketName: string;
  applicant: string;
  startDate: string;
  endDate: string;
  status?: any;
  onClick?: any;
}
const AirTicketTile: React.FC<contentTileType> = ({
  endDate,
  ticketName,
  startDate,
  applicant,
  status,
  onClick,
}) => {
  const { t } = useTranslation();
  const trans = t;

  return (
    <Grid container className="claim-history-AirTicket-container">
      <Grid item xs={10}>
        <Grid container>
          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.title,
              fontFamily: fonts.fontFamily,
              color: themes.blackDefault,
              fontWeight: 'bold',
              textTransform: 'capitalize',
            }}
          >
            {ticketName}
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.subtitle,
              fontFamily: fonts.fontFamily,
              color: themes.defaultIcon,
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              textTransform: 'capitalize',
              letterSpacing: '0.01px',
              marginTop: '10px',
            }}
          >
            {trans('Type')} :{' '}
            <span style={{ color: themes.blackDefault }}>{applicant}</span>{' '}
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.subtitle,
              fontFamily: fonts.fontFamily,
              color: themes.defaultIcon,
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              letterSpacing: '0.01px',
              marginTop: '2px',
              textTransform: 'capitalize',
            }}
          >
            {trans('Start')} :{' '}
            <span style={{ color: themes.blackDefault }}>
              <DateField value={startDate} format={baseDateFormatting} />
            </span>{' '}
            <span style={{ margin: '0 3px' }}>|</span>
            {trans('End')} :{' '}
            {moment(endDate).isValid() ? (
              <span style={{ color: themes.blackDefault }}>
                <DateField value={endDate} format={baseDateFormatting} />
              </span>
            ) : (
              '--'
            )}
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.subtitle,
              fontFamily: fonts.fontFamily,
              color: themes.defaultIcon,
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              letterSpacing: '0.01px',
              textTransform: 'capitalize',
            }}
          >
            {trans('Status')} :{' '}
            {status == 0 ? (
              <span style={{ color: themes.defaultMisc }}>
                {trans('Waiting for Approval')}
              </span>
            ) : status == 2 ? (
              <span style={{ color: themes.defaultError }}>
                {trans('Rejected')}
              </span>
            ) : (
              <span style={{ color: themes.defaultSuccess }}>
                {trans('Approved')}
              </span>
            )}
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        xs={2}
        style={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'flex-end',
          flexDirection: 'row',
        }}
      >
        <Box className="icon-box_claim_AirTicket_history" onClick={onClick}>
          {' '}
          <i className="las la-eye" color={themes.primaryMain} />{' '}
        </Box>
      </Grid>
    </Grid>
  );
};

export default AirTicketTile;
